/**
 * WebView Bridge Utility
 *
 * Provides helpers for communicating with the React Native WebView shell.
 * When the website is loaded inside a React Native WebView, the native app
 * listens for postMessage events. This module centralises that communication.
 *
 * Supported message types sent TO the native app:
 *   LOGOUT          – user-initiated logout
 *   TOKEN_INVALID   – API returned 401/403 (token no longer valid)
 *   SESSION_EXPIRED – session timed out (treated same as TOKEN_INVALID)
 */

/**
 * Returns true when the page is rendered inside a React Native WebView.
 */
export const isWebView = () => {
  return typeof window !== "undefined" && !!window.ReactNativeWebView;
};
/**
 * Send a structured message to the React Native WebView host.
 *
 * @param {string} type    – One of LOGOUT | TOKEN_INVALID | SESSION_EXPIRED
 * @param {object} payload – Optional extra data
 * @returns {boolean} true if the message was sent (i.e. we are in a WebView)
 */
export const postWebViewMessage = (type, payload = {}) => {
  if (isWebView()) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type, payload }));
    return true;
  }
  return false;
};
